import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightBulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 8.32929V9.5C4.5 10.0523 4.94772 10.5 5.5 10.5C6.05228 10.5 6.5 10.0523 6.5 9.5V8.32929M5.5 0.5V1M1 5.5H0.5M2.25 2.25L1.94995 1.94995M8.75 2.25L9.05012 1.94995M10.5 5.5H10M8.5 5.5C8.5 7.15685 7.15685 8.5 5.5 8.5C3.84315 8.5 2.5 7.15685 2.5 5.5C2.5 3.84315 3.84315 2.5 5.5 2.5C7.15685 2.5 8.5 3.84315 8.5 5.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLightBulb;
